import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

interface IActionForPopoverProps {
  permission: boolean
  handleAction: () => void
  icon?: React.ReactNode
  label: string
  isDelete?: boolean
  disabled?: boolean
}

export const ActionForPopover = ({
  permission,
  handleAction,
  icon,
  label,
  isDelete,
  disabled,
}: IActionForPopoverProps) => {
  return (
    <>
      {permission && (
        <div
          onClick={!disabled ? handleAction : undefined}
          className={clsx(s.menuItem, {
            [s.delete]: isDelete,
            [s.disabled]: disabled,
          })}
        >
          {icon && <span className={s.menuItemIcon}>{icon}</span>}
          <span className={s.menuItemLabel}>{label}</span>
        </div>
      )}
    </>
  )
}
